import { useCacheSlice } from '../hooks'

export type ReportsPerson = {
  prof_id: string
  full_name: string
  email: string
  prof_type: string | null
}

export type ReportsData = {
  managers: ReportsPerson[]
  manages: ReportsPerson[]
}

export function useReportsCache() {
  const { data, isLoading } = useCacheSlice('reports')
  const reports = data as ReportsData
  return { reports, isLoading }
}
